import { FC, PropsWithChildren } from "react";

export type PageLayoutProps = PropsWithChildren

export const PageLayout: FC<PageLayoutProps> = ({ children }) =>
  <main className="container my-12 mx-auto px-4 md:px-12 flex flex-col gap-8">
    {children}
  </main>;
